// extracted by mini-css-extract-plugin
export default {"label":"Label_label__dKnfh","labelUppercase":"Label_labelUppercase__0X4xz"};